import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import ReactDOM from 'react-dom';
import debounce from 'lodash/debounce';
import reduxStore from '../../../../reduxStore';
import React from 'react';

// ======================================================
// this component extends another component and will run
// the 'clickedOutside' function defined on that component
// if users click outside of it

// clickedOutside: called when the user clicks outside node

// ignoreClickOutsideIf: if returns true then do not run
// the clickedOutside callback

// ======================================================

var wrapWithOutsideClickEmotion = function wrapWithOutsideClickEmotion(ComposedComponent) {
  return /*#__PURE__*/function (_React$Component) {
    function wrappedWithOutsideClick(props) {
      var _this;
      _classCallCheck(this, wrappedWithOutsideClick);
      _this = _callSuper(this, wrappedWithOutsideClick, [props]);
      _this.checkForOutsideClick = _this.checkForOutsideClick.bind(_this);
      return _this;
    }
    _inherits(wrappedWithOutsideClick, _React$Component);
    return _createClass(wrappedWithOutsideClick, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.mouseDownEventCb = debounce(this.checkForOutsideClick, 300, {
          leading: true,
          trailing: false
        });
        document.addEventListener('click', this.mouseDownEventCb, true);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        document.removeEventListener('click', this.mouseDownEventCb, true);
      }
    }, {
      key: "checkcomponentRef",
      value: function checkcomponentRef() {
        return this.composedComponentRef && this.composedComponentRef.current;
      }
    }, {
      key: "checkForOutsideClick",
      value: function checkForOutsideClick(e) {
        var isModalOpen = reduxStore.getAppState().getIn(['modal', 'isOpen']);
        if (this.checkcomponentRef() && this.composedComponentRef.current.ignoreClickOutsideIf && this.composedComponentRef.current.ignoreClickOutsideIf(e) || isModalOpen) {
          return;
        }
        if (this.checkcomponentRef() && this.composedComponentRef.current.clickedOutside) {
          var domNode = ReactDOM.findDOMNode(this);
          if (!(domNode && domNode.contains(e.target))) {
            this.composedComponentRef.current.clickedOutside(e);
          }
        }
      }
    }, {
      key: "render",
      value: function render() {
        this.composedComponentRef = React.createRef();
        return /*#__PURE__*/React.createElement(ComposedComponent, Object.assign({
          ref: this.composedComponentRef
        }, this.props));
      }
    }]);
  }(React.Component);
};
export default wrapWithOutsideClickEmotion;